import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/app/App'
// Font self-host (skill 3.A cấm <link> Google Fonts ở production)
// Be Vietnam Pro: chữ, phủ đủ dấu tiếng Việt + ký tự ₫ (U+20AB)
import '@fontsource/be-vietnam-pro/400.css'
import '@fontsource/be-vietnam-pro/500.css'
import '@fontsource/be-vietnam-pro/600.css'
import '@fontsource/be-vietnam-pro/700.css'
// IBM Plex Mono: SỐ. Be Vietnam Pro không có tnum và chữ số rộng lệch nhau
// gần gấp đôi (số 1 = 385, số 4 = 710) nên cột tiền sẽ so le. Plex Mono mọi
// chữ số rộng đúng 600 đơn vị.
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'
import '@/shared/assets/styles/global.css'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

